import styled from "styled-components";

export const PostitNone = styled.div`
  background-color: #ebebf4;
  padding: 10px;
  height: 300px;
  overflow: scroll;
  transform: ${(props) => props.transform};
`;
